import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function TransferCircle({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>TransferCircle</title>1
      <path
        d="M9.80078 14.1479C9.80078 14.9265 10.4246 15.5576 11.1941 15.5576L12.4879 15.5576C13.3124 15.5576 13.9808 14.8814 13.9808 14.0472C13.9808 13.2131 13.3124 12.5369 12.4879 12.5369L11.2936 12.5369C10.4692 12.5369 9.80078 11.8606 9.80078 11.0265C9.80078 10.1923 10.4692 9.51609 11.2936 9.51609L12.5874 9.51609C13.357 9.51609 13.9808 10.1472 13.9808 10.9258M11.8908 8.60986L11.8908 9.51609M11.8908 15.5576L11.8908 16.4639"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3892 5.08097C12.8766 4.56348 11.2418 4.55034 9.7213 5.04346C8.20085 5.53658 6.87367 6.51037 5.93182 7.82392C4.98997 9.13747 4.48231 10.7226 4.48231 12.35V12.3501H5.33672C5.96161 12.3501 6.27757 13.2296 5.83523 13.7426L4.0167 15.8518C3.74287 16.1694 3.30053 16.1694 3.02669 15.8518L1.20817 13.7426C0.765822 13.2296 1.07476 12.3501 1.69966 12.3501H2.83231V12.35C2.83231 10.3654 3.45141 8.43228 4.6 6.83039C5.7486 5.22851 7.36712 4.04095 9.22133 3.43959C11.0755 2.83822 13.0692 2.85424 14.9139 3.48533C16.7586 4.11642 18.3586 5.32984 19.4823 6.94999C19.7454 7.32939 19.6572 7.85455 19.2853 8.12296C18.9133 8.39137 18.3984 8.30139 18.1353 7.92199C17.2139 6.59347 15.9019 5.59847 14.3892 5.08097Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.61076 19.6187C11.1234 20.1362 12.7582 20.1494 14.2787 19.6562C15.7991 19.1631 17.1263 18.1893 18.0682 16.8758C19.01 15.5623 19.5176 13.9772 19.5177 12.3499H18.6633C18.0384 12.3499 17.7224 11.4704 18.1648 10.9573L19.9833 8.84812C20.2571 8.53051 20.6995 8.53051 20.9733 8.84812L22.7918 10.9573C23.2342 11.4704 22.9252 12.3499 22.3003 12.3499H21.1677C21.1676 14.3344 20.5486 16.2675 19.4 17.8693C18.2514 19.4712 16.6329 20.6588 14.7787 21.2601C12.9245 21.8615 10.9308 21.8455 9.08607 21.2144C7.24139 20.5833 5.64142 19.3699 4.51771 17.7497C4.25456 17.3703 4.34277 16.8452 4.71473 16.5767C5.0867 16.3083 5.60155 16.3983 5.8647 16.7777C6.78615 18.1062 8.09812 19.1012 9.61076 19.6187Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
